/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * UploadCloudIcon
 */
export default class UploadCloudIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M23.328 11.1C22.272 9.2 20.352 8 18.24 8h-.576c-1.44-4.4-5.856-6.9-10.272-5.7-2.208.6-4.128 2.1-5.28 4.1-1.152 2.1-1.536 4.5-.96 6.8.384 1.5 1.056 2.8 2.016 3.8.384.4.96.4 1.344 0 .384-.4.384-1 0-1.4-.672-.7-1.248-1.7-1.44-2.8-.48-1.9-.192-3.7.672-5.3.96-1.6 2.4-2.7 4.128-3.2 3.648-1 7.2 1.2 8.16 5 .096.4.48.8.96.8h1.248c1.44 0 2.688.8 3.36 2.1.96 1.9.288 4.4-1.536 5.4-.48.3-.672.9-.384 1.4.192.3.48.5.864.5.192 0 .288 0 .48-.1 2.688-1.7 3.744-5.4 2.304-8.3zm-10.176.2c-.096-.1-.192-.2-.288-.2-.192-.1-.48-.1-.768 0-.096.1-.192.1-.288.2l-3.84 4c-.384.4-.384 1 0 1.4.384.4.96.4 1.344 0l2.208-2.3V21c0 .6.384 1 .96 1s.96-.4.96-1v-6.6l2.208 2.3c.192.2.48.3.672.3.192 0 .48-.1.672-.3.384-.4.384-1 0-1.4l-3.84-4z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

